module.exports = __webpack_public_path__ + "img/01.f1e1c9ea.png";